import {
  CardContent,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import { isThisMinute } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import StyledTableRow from "../../components/StyledTableRow";
import {
  convertToThousands,
  getUniqueValues,
  _isNaN,
  countOrACVFormatter,
} from "../../util/customFunctions";
import * as d3 from "d3";
import { getMixKey } from "../../util/generateHeadings";
import {
  customSortedOppType,
  customSortedSegments,
} from "../../util/customSortings";
import { deSnake } from "../../util/dataFormatter";
import { color } from "d3";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
// import ExcelExportButton from "../../components/xlsx-export/xlsxexport";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CustomWidthTooltip from "../../components/Buttons/Expand_Collapse_Tooltip";

const useStyle = makeStyles((theme) => ({
  root: {},
  sticky: {
    position: "sticky",
    left: -1,
    background: "white",
    // outline: "0.5px solid lightgrey",
    // outlineOffset: "-1.5px",
    // Create a pseudo-element for the fixed right border
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "1.5px", // Adjust the thickness as needed
      background: "lightgrey", // Adjust the color as needed
    },
  },
  stickyHeader: {
    position: "sticky",
    top: -1,
    background: "white",
    // outline: "0.2px solid lightgrey",
    // outlineOffset: "-1.5px",
    outline: "lightgrey solid 1px",
    outlineOffset: "-1.5px",
    zIndex: 5,
    // Create a pseudo-element for the fixed right border
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "0.5px", // Adjust the thickness as needed
      // background: "lightgrey", // Adjust the color as needed
    },
  },
  content: { width: "100%" },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repText: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    minWidth: "169px",
    fontWeight: "inherit",
  },
  repNumber: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: "inherit",
  },
  repNumberACV: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "92px",
    fontWeight: "inherit",
  },
  repNumberPercent: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "90px",
    fontWeight: 600,
    cursor: "pointer",
  },
  repTextH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    fontWeight: 600,
  },
  repNumberH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: 600,
  },
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    width: "5%",
  },
  inner: {
    height: 375,
    minWidth: 500,
  },
  chart: {
    height: "100%",
  },
  tableHeader: {
    fontSize: "15px",
    whiteSpace: "normal",
    textAlign: "center",
  },
  tableCell: {
    whiteSpace: "normal",
  },
  indentName: {
    paddingLeft: 30,
  },
  blackLabel: {
    color: "black",
  },
  inputFieldContainers: {
    marginBottom: 10,
    padding: 10,
    [theme.breakpoints.up("lg")]: {
      paddingRight: 0,
    },
  },
  fontBold: {
    fontWeight: 600,
  },
  stickyColumn: {
    minWidth: 200,
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 1,
  },
}));
export default function GoLiveWithTeamTable(props) {
  const classes = useStyle();
  const tableRef = React.createRef();
  const tableContainerRef = useRef();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [rowPin, setrowPin] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [isSticky, setIsSticky] = useState(false);
  const [parentWidth, setparentWidth] = useState();

  const HtmlTooltip = withStyles((theme) => ({
      tooltip: {
        backgroundColor: "rgb(255,255,255,0.8)",
        color: "black",
        fontFamily: "roboto",
        fontSize: theme.typography.pxToRem(14),
        borderRadius: "1rem",
        padding: "0px",
        boxShadow: "0 0.1rem 0.1rem 0",
        marginTop: "0.4rem",
      },
    }))(Tooltip);


    const projectedYieldTooltip = (
        <>
          {Array(1)
            .fill()
            .map((item) => (
              <>
                <div
                  style={{
                    // borderTop: "solid #4471C4",
                    borderRadius: "0.3rem",
                    padding: "0px",
                    margin: 0,
                    borderWidth: "0.3rem",
                  }}
                >
                  <div className="container">
                    <Typography
                      style={{ padding: "0.1rem" }}
                      className="heading-style"
                    >{`(Attainment / Quota) / # of Reps in team`}</Typography>
                  </div>
                </div>
              </>
            ))}
        </>
      );

  let countinc = 0;
  let globalExpand = [];

  const handleExpandClick = (rowId) => {
    setExpandedRows((prevExpandedRows) => {
      const isRowExpanded = prevExpandedRows.includes(rowId);
      if (isRowExpanded) {
        return prevExpandedRows.filter((expandedRow) => expandedRow !== rowId);
      } else {
        return [...prevExpandedRows, rowId];
      }
    });
  };

  useEffect(() => {
    setExpandedRows(globalExpand);
  }, []);

  const globalExpandData = (con) => {
    if (con === true) {
      setExpandedRows(globalExpand);
      // setglobalExpandArrow(true);
    } else {
      setExpandedRows([]);
      // setglobalExpandArrow(false);
    }
  };

  const quarter = props.data.map(item => item['month']).filter(getUniqueValues);
  console.log(quarter, 'QUARETERERETERER')

  // const uniqueQuarters = quarter.map(item => item['month']).filter(getUniqueValues)
  const uniqueQuarters = quarter;

    const uniqueAttainment = props.data
      .filter((item) => item['month'] === "Total")
      .sort((a, b) =>
        b.perc === a.perc
          ? b.actual - a.actual
          : b.perc - a.perc
      );
  
  
    let uniqueOwner = uniqueAttainment.filter(f => f.rep !== 'Total')
      .map((item) => item.rep)
      .filter(getUniqueValues)
      .filter((item) => item !== null);
    uniqueOwner =
      props.toggleValue === "PercSort" ? [...uniqueOwner] : [...uniqueOwner.sort()];

  let uniqueTeams = uniqueAttainment.filter(f => f.team !== 'Total')
  .map((item) => item.team)
  .filter(getUniqueValues)
  .filter((item) => item !== null);
  uniqueTeams =
    props.toggleValue === "PercSort"
      ? uniqueTeams
      : props.logicalTeams
          .filter((e) => uniqueTeams.indexOf(e) !== -1)
          .filter(Boolean);


  // console.log((uniqueOwner.map(owner => quarter.filter(x => x.Owner_Name === owner && x.Quota !== null).length < uniqueQuarters.length ) ))


  useEffect(() => {
    const tableContainer = document.getElementById("myTableContainer-second");

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    // Check for overflow initially and whenever the component updates
    handleOverflowCheck();

    // Attach a resize event listener to check for overflow when the window is resized
    window.addEventListener("resize", handleOverflowCheck);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("resize", handleOverflowCheck);
    };
  }, []);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      if (tableContainer.scrollLeft > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      if (tableContainer.scrollTop > 0) {
        setrowPin(true);
      } else {
        setrowPin(false);
      }
    };

    // Attach a scroll event listener to the TableContainer
    tableContainer.addEventListener("scroll", handleScroll);

    return () => {
      // Clean up the event listener when the component unmounts
      tableContainer.removeEventListener("scroll", handleScroll);
    };
  }, [classes.sticky]);

  useEffect(() => {
    // Get the width of the parent TableContainer
    const parentWidth = tableContainerRef.current.getBoundingClientRect().width;
    setparentWidth(parentWidth);
  }, [parentWidth]);
  return (
    <div
      className={classes.root}
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <CardContent className={classes.content} style={{ padding: "1rem" }}>
        {/* {isOverflowing ? (
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "10px",
              // marginRight: "10px",
            }}
          >
            <CopyTablesObject tableRef={tableRef} />
          </div>
        ) : null} */}
        {parentWidth !== undefined ? (
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "0.6rem",
              // marginRight: "1rem",
              width: `${parentWidth}px`,
            }}
          >
            <CopyTablesObject tableRef={tableRef} />
          </div>
        ) : null}
         <Grid
              item
              container
              xs={10}
              justify="flex-start"
              alignItems="flex-end"
            >
              <Typography variant="body2" style={{ paddingLeft: "1rem" }}>
              
              </Typography>
            </Grid>
        <Grid container justify="flex-start" style={{ padding: "1rem" }}>
          <TableContainer
            className={classes.mainTable}
            id="myTableContainer-second"
            ref={tableContainerRef}
            style={{
              borderLeft: isSticky ? "0.5px solid lightgrey" : "",
              borderTop: rowPin ? "0.5px solid lightgrey" : "",
              maxHeight: "85vh",
              // height: "85vh",
            }}
          >
            {/* {isOverflowing === false ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "10px",
                  // marginRight: "10px",
                }}
              >
                <CopyTablesObject tableRef={tableRef} />
              </div>
            ) : null} */}
            <Table
              ref={tableRef}
              size="small"
              aria-label="html table"
              style={{ tableLayout: "auto", width: "initial" }}
              data-test={
                props.dataTest
                  ? props.dataTest
                  : "quota-attainment-detail-table"
              }
            >
              <TableHead style={{ position: "sticky", top: -1, zIndex: 5 }}>
                <TableRow
                  style={{
                    fontWeight: 600,
                    paddingLeft: 5,
                    position: "sticky",
                    outline: "lightgrey solid 0.5px",
                    outlineOffset: "-1.5px",
                  }}
                  // className={rowPin ? classes.stickyHeader : ""}
                >
                  <TableCell
                    align="center"
                    // className={`${classes.repHeader}`}
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.repHeader}`
                        : classes.repHeader
                    }
                    colSpan={1}
                    style={{ minWidth: 150, background: "white" }}
                  >
                    {props.selectedTimeFrame}
                  </TableCell>
                  {uniqueQuarters.map((i, index) => {
                    return (
                      <TableCell
                        key={i}
                        align="center"
                        style={
                          index % 2 === 0
                            ? { background: "#4471c4", color: "white" }
                            : {
                                background: "#5b9bd5",
                                color: "white",
                                padding: "10px 0",
                              }
                        }
                        className={classes.repHeader}
                        colSpan={4}
                      >
                        {i} 
                      </TableCell>
                    );
                  })}
                

                  {uniqueQuarters.length === 0 && (
                    <TableCell
                      rowSpan={8}
                      className={classes.repHeader}
                      style={{ width: 400, textAlign: "center" }}
                    >
                      No data available
                    </TableCell>
                  )}
                </TableRow>
                <TableRow
                  style={{
                    fontWeight: 600,
                    paddingLeft: 5,
                    outline: "lightgrey solid 1px",
                    outlineOffset: "-1.5px",
                  }}
                  // className={rowPin ? classes.stickyHeader : ""}
                >
                  <TableCell
                    align="center"
                    // className={`${classes.repHeader}`}
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.repHeader}`
                        : classes.repHeader
                    }
                    colSpan={1}
                    style={{
                      outline: "lightgrey solid 0.5px",
                      outlineOffset: "-1.5px",
                      background: "white",
                    }}
                  >
                    {/* {"Rep"} */}
                    <div style={{ display: "flex" }}>
                      <div style={{ marginTop: "2.5px", marginLeft: "30px" }}>
                        {"Rep"}
                      </div>
                      { (
                        <>
                          <CustomWidthTooltip
                            title={"Expand All"}
                            placement="top-start"
                            style={{ marginTop: "13rem" }}
                          >
                            <KeyboardArrowDownIcon
                              onClick={() => globalExpandData(true)}
                              style={{ color: "gray" }}
                            />
                          </CustomWidthTooltip>
                          <CustomWidthTooltip
                            title={"Collapse All"}
                            placement="top-start"
                          >
                            <KeyboardArrowUpIcon
                              onClick={() => globalExpandData(false)}
                              style={{ color: "gray" }}
                            />
                          </CustomWidthTooltip>
                        </>
                      ) }
                    </div>
                  </TableCell>
                  {uniqueQuarters.map((i) => {
                    return (
                      <React.Fragment key={i}>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                          style={{ background: "white" }}
                        >
                          Go Live Goal
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                          style={{ background: "white" }}
                        >
                          Goal
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                          style={{ background: "white" }}
                        >
                          Actual
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.repHeader}
                          colSpan={1}
                          style={{ background: "white" }}
                        >
                          Attain.%
                        </TableCell>
                      </React.Fragment>
                    );
                  })}
                
                </TableRow>
              </TableHead>
              <TableBody>
                { uniqueTeams.map((team, i) => {
                      globalExpand.push(i);
                      countinc = countinc + 1;
                      
                      let repData = props.data
                        .filter((item) => item['team'] === team)
                        .sort((a, b) =>
                          b.perc === a.perc
                            ? b.actual - a.actual
                            : b.perc - a.perc
                        );
                      const rps =  props.data
                        .filter(
                          (item) =>
                            item['team'] === team && item['month'] === 'Total'
                        )
                        .sort((a, b) =>
                          b.perc === a.perc
                            ? b.actual - a.actual
                            : b.perc - a.perc
                        )
                        .map((item) => item.rep)
                        .filter(getUniqueValues) ;

                        let reps = props.toggleValue === "PercSort" ? rps : rps.sort()
                      
                      return (
                        <>
                          {" "}
                          <StyledTableRow
                            key={i}
                            style={
                              props.showReps === true
                                ? { background: "#dae3f3" }
                                : {}
                            }
                          >
                            <TableCell
                              align="left"
                              // className={`${classes.table} ${classes.repHeader}`}
                              className={
                                isSticky
                                  ? `${classes.sticky} ${classes.table} ${classes.repHeader}`
                                  : `${classes.table} ${classes.repHeader}`
                              }
                              // style={
                              //   isSticky && countinc % 2 === 0
                              //     ? {
                              //         background: "#f5f5f5",
                              //         paddingLeft: "25px",
                              //       }
                              //     : { paddingLeft: "25px" }
                              // }
                              style={
                                props.showReps === true
                                  ? { background: "#dae3f3" }
                                  : isSticky && countinc % 2 === 0
                                  ? { background: "#f5f5f5" }
                                  : {}
                              }
                              colSpan={1}
                              onClick={() => handleExpandClick(i)}
                            >
                              {/* {team} */}
                              <div style={{ display: "flex" }}>
                                {props.showReps === true ? (
                                  expandedRows.includes(i) ? (
                                    <KeyboardArrowUpIcon
                                      style={{ color: "gray" }}
                                    />
                                  ) : (
                                    <KeyboardArrowDownIcon
                                      style={{ color: "gray" }}
                                    />
                                  )
                                ) : null}
                                <div style={{ marginTop: "3px" }}>{team}</div>
                              </div>
                            </TableCell>

                            {uniqueQuarters.map((qtr, j) => {
                              
                              // console.log(props.data.filter(item => item.Owner_Name === owner).map(item => item.Quota)[0] === 0)
                              

                              return (
                                <>
                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                  >
                                    {" "}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                    
                                   
                                  >
                                    {''}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                  >
                                    {''}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                  >
                                    {''}
                                  </TableCell>
                                  
                                </>
                              );
                            })}

                            
                          </StyledTableRow>
                          {expandedRows.includes(i) &&
                              (
                                
                                reps.map((rep, i) => {
                              countinc = countinc + 1;
                              const repsData = repData.filter(
                                (item) => item.rep === rep
                              );
                              return (
                                <StyledTableRow key={i}>
                                  <TableCell
                                    align="left"
                                    // className={`${classes.table} ${classes.indentName}`}
                                    className={
                                      isSticky
                                        ? `${classes.sticky} ${classes.table} ${classes.indentName}`
                                        : `${classes.table} ${classes.indentName}`
                                    }
                                    style={
                                      isSticky && countinc % 2 === 0
                                        ? {
                                            background: "#f5f5f5",
                                            paddingLeft: "25px",
                                          }
                                        : { paddingLeft: "25px" }
                                    }
                                    colSpan={1}
                                  >
                                    {rep}
                                  </TableCell>
                                  {uniqueQuarters.map((qtr, j) => {
                                    const QuotaData = countOrACVFormatter(repsData
                                      .filter(
                                        (item) =>
                                          item['month'] === qtr &&
                                          item.rep === rep
                                      )
                                      .reduce((a,b) => a+b.goal, 0), true);
                                    // console.log(props.data.filter(item => item.Owner_Name === owner).map(item => item.Quota)[0] === 0)
                                    const acvData = countOrACVFormatter(repsData
                                      .filter(
                                        (item) =>
                                          item['month'] === qtr &&
                                          item.rep === rep
                                      )
                                      .reduce((a,b) => a+b.actual, 0), true);
                                    const attainmentData = `${Math.round(repsData
                                      .filter(
                                        (item) =>
                                          item['month'] === qtr &&
                                          item.rep === rep
                                      )
                                      .reduce((a,b) => a+b.perc, 0) * 100)}%`;
                                      const goLiveGoal = qtr === 'Total' ? '' : `${Math.round(repsData
                                        .filter(
                                          (item) =>
                                            item['month'] === qtr &&
                                            item.rep === rep
                                        )
                                        .reduce((a,b) => a+b.goLiveGoal, 0) * 100)}%`;
                                    return (
                                      <>
                                        <TableCell
                                          align="right"
                                          className={classes.repNumber}
                                          colSpan={1}
                                        >
                                          {goLiveGoal}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          className={classes.repNumber}
                                          colSpan={1}
                                        >
                                          {QuotaData}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          className={classes.repNumber}
                                          colSpan={1}
                                          style={{cursor: 'pointer'}}
                                          onClick={() =>
                                            props.handleChangeLocation(
                                              "drilldownOnGraph3",
                                              {
                                                row: rep === 'Total' ? reps.filter(f => f !== 'Total') : rep,
                                                cell: qtr === 'Total' ? uniqueQuarters.filter(f => f!== 'Total') : qtr ,
                                              },
                                              team,
                                              props.selectedTimeFrame
                                            )
                                          }
                                        >
                                          {acvData}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          className={classes.repNumber}
                                          colSpan={1}
                                          
                                        >
                                          {attainmentData}
                                        </TableCell>
                                      </>
                                    );
                                  })}

                                </StyledTableRow>
                              );
                            })
                              )
                            }
                        </>
                      );
                    })
                  }

                
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        
      </CardContent>
    </div>
  );
}
